import { Badge, Stack, Typography } from '@mui/material'

import { form } from '../../../../formState'
import * as OrderTexts from '../../../../intl'

import type { ExecutionEventsFormValues } from '../../../../typings'
import type { Props } from '../../typings'

import { TimePickerField } from './components/TimePickerField/TimePickerField'

export function ReportedExecutionDetails(props: Props) {
  const {
    values: { timeInSec, timeOutSec },
    accountPreferences,
    workingDayStartSec,
  } = props

  const h24 = accountPreferences.timeFormat === 'HH:mm'
  const format = h24 ? '24' : '12'

  const timeOutCurrentValue = form.useFormField('timeOutSec').field.value
  const timeInCurrentValue = form.useFormField('timeInSec').field.value

  const checkValidation = (timeIn, timeOut) => {
    if (timeIn >= 0 && timeOut >= 0) {
      if (
        ((timeIn < workingDayStartSec && timeOut <= workingDayStartSec) ||
          (timeIn > workingDayStartSec && timeOut >= workingDayStartSec)) &&
        timeOut < timeIn
      ) {
        return OrderTexts.getValidationExecutionEventsTimeOutOverlappingText()
      }

      if (workingDayStartSec > 0 && timeIn <= workingDayStartSec && timeOut > workingDayStartSec) {
        return OrderTexts.getValidationExecutionEventsTimeOutAcrossDayEndText()
      }
    }
  }

  form.useAddFieldValidation('timeInSec', (field, _formApi) => {
    const validationError = checkValidation(field.value, timeOutCurrentValue)
    if (validationError) {
      return validationError
    }
  })

  form.useAddFieldValidation('timeOutSec', (field, _formApi) => {
    const validationError = checkValidation(timeInCurrentValue, field.value)
    if (validationError) {
      return validationError
    }
  })

  const timeInLabel = (
    <Stack direction="row" alignItems="center" spacing={2} ml={1}>
      <Badge
        variant="standard"
        badgeContent="1"
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: timeInSec === -1 ? 'action.disabled' : 'warning.main',
            color: timeInSec === -1 ? 'action.disabled' : 'default',
          },
        }}
      />
      <Typography variant="caption">{OrderTexts.getReportedTimeInLabel()}</Typography>
    </Stack>
  )

  const timeOutLabel = (
    <Stack direction="row" alignItems="center" spacing={2} ml={1}>
      <Badge
        variant="standard"
        badgeContent="2"
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: timeOutSec === -1 ? 'action.disabled' : 'warning.main',
            color: timeOutSec === -1 ? 'action.disabled' : 'default',
          },
        }}
      />
      <Typography variant="caption">{OrderTexts.getReportedTimeOutLabel()}</Typography>
    </Stack>
  )

  return (
    <form.Fieldset direction="row" spacing={2}>
      <TimePickerField<'timeInSec', ExecutionEventsFormValues>
        name="timeInSec"
        timePickerProps={{
          label: timeInLabel,
          testId: 'timeInSec',
          format: format,
        }}
      />
      <TimePickerField<'timeOutSec', ExecutionEventsFormValues>
        name="timeOutSec"
        timePickerProps={{
          label: timeOutLabel,
          testId: 'timeOutSec',
          format: format,
        }}
      />
    </form.Fieldset>
  )
}
